<template>
  <div class="home">
    <div class="banner" :style="{ backgroundImage: 'url(' + pageDetail.homepagebanner + ')' }">
      <div class="container">
        <div :class="'banner-text ' + [toptitle2 ? 'toptitle2' : '']">
          <h2>{{ pageDetail.homepagetext }}</h2>
          <h5>{{ pageDetail.homepagetext2 }}</h5>
        </div>
      </div>
    </div>
    <div class="homeAbout">
      <div class="container">
        <div class="left"><img src="../assets/hometop1.png"></div>
        <div class="mid">
          <div class="logosbar"><img src="../assets/logos.png" class="logos">博奥润康</div>
          <div>
            <h2>{{ pageDetail.homepagetext4 }}</h2>
          </div>
          <div class="sintro">{{ pageDetail.homepageabout }}...</div>
          <div><el-button type="primary" round @click="gourl('about')">了解更多 <i
                class="el-icon-arrow-right"></i></el-button></div>
        </div>
        <div class="right"><img src="../assets/hometop2.png"></div>
      </div>
    </div>
    <div class="mainwrap">


      <div class="midbanner">
        <div class="container">
          <div class="logosbar"><img src="../assets/logos.png" class="logos">博奥润康</div>
          <div>
            <h2>{{ pageDetail.homepagetext3 }}</h2>
          </div>
          <div class="piclist">
            <div class="picli" @click="gourl('products?proid=26')">
              <div class="img"><img src="../assets/homemid1.png" /></div>
              <div class="text">司法鉴定项目</div>
            </div>
            <div class="picli" @click="gourl('products?proid=22')">
              <div class="img"><img src="../assets/homemid2.png" /></div>
              <div class="text">HPV基因分型检测</div>
            </div>
            <div class="picli" @click="gourl('products?proid=23')">
              <div class="img"><img src="../assets/homemid3.png" /></div>
              <div class="text">呼吸道病原菌核酸检测</div>
            </div>
            <div class="picli" @click="gourl('products?proid=24')">
              <div class="img"><img src="../assets/homemid4.png" /></div>
              <div class="text">叶酸代谢能⼒基因检测</div>
            </div>
          </div>
        </div>
      </div>

      <div class="container homejoin">
        <el-row :gutter="60">
          <el-col :span="10">
            <div class="logosbar"><img src="../assets/logos.png" class="logos">博奥润康</div>
            <h2>秉承优秀的"政、产、学、研、用"一体化理念</h2>
            <p>立足新一代生物检测技术，为司法DNA鉴定医学领域、临床医学、预防医学、健康管理和科学研究等领域客户提供高品质的产品和服务。为人民群众健康保驾护航为科技造福人类做出卓越贡献</p>
            <div><el-button type="primary" round @click="gourl('join')">探索职业机会 <i class="el-icon-arrow-right
"></i></el-button></div>
          </el-col>
          <el-col :span="14"><img src="../assets/homejoin.png"></img></el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { productApi, systemApi } from '@/api'

export default {
  name: 'Home',
  data() {
    return {
      pageDetail: '',
      toptitle2: false,
      products: [],
    }
  },
  created() {
    // 首先尝试获取当前已有的系统设置
    let systemSettings = this.$store.getters.systemSettings
    if (Object.keys(systemSettings).length > 0) {
      // 如果已经有数据，直接使用
      this.pageDetail = systemSettings
      console.log('从store获取的systemSettings:', systemSettings)
    } else {
      // 如果没有数据，输出提示信息
      console.log('systemSettings 暂时空缺，正在监听更新...')
    }
    
    // 监听系统设置变化
    this.unwatch = this.$store.watch(
      (state) => state.systemSettings,
      (newSettings) => {
        if (newSettings && Object.keys(newSettings).length > 0) {
          this.pageDetail = newSettings
          //首页加载时路由尚未获取页面设置数据，所以这里需要先指定一个
          document.title = newSettings.sitename
          // console.log('监听到更新的systemSettings:', newSettings)
        }
      }
    )
    
    setTimeout(() => {
      this.toptitle2 = true;
    }, 500);
  },

  methods: {
    gourl(e) {
      this.$router.push({ path: e })
    },
    // async fetchProducts() {
    //   try {
    //     const response = await productApi.getProductList()
    //     // 直接使用响应数据，因为request.js已经处理了错误情况
    //     // 只显示前两个产品
    //     this.products = response.data.slice(0, 2)
    //   } catch (error) {
    //     console.error('获取产品列表失败:', error)
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.home {
  text-align: justify;

  h2 {
    font-size: 24px;
    margin: 15px 0;
    font-weight: normal
  }

  .sintro {
    font-size:16px;
    line-height:1.8;
    margin-bottom: 20px;
  }

  .banner {
    height: 500px;
    width: 100%;
    background-color:#eee;
    background-repeat: no-repeat;
    background-position: top center;
    background-size: 100% 100%;
    display: flex;
    align-items: center;

    .banner-text {
      opacity: 0;
      margin-top: 150px;
      margin-left: 100px;
      text-shadow: -2px -2px 1px #313131;

      h2 {
        font-size: 48px;
        letter-spacing: 0px;
        line-height: 32px;
        color: #FFFFFF;
      }

      h5 {
        color: #fff;
        margin: 0;
        padding: 0;
        font-size: 24px;
        font-weight: normal;
      }
    }

    .toptitle2 {
      margin-top: 0px;
      opacity: 1;
      transition: all 1000ms ease-in-out;
    }

  }

  .midbanner {
    width: 100%;
    padding: 40px 0;
    background: #F2F2F2;
    display: flex;
    align-items: center;
    margin: 0 0 80px 0;

    .piclist {
      width: 1230px;
      position: relative;

      .picli {
        width: calc(25% - 30px);
        margin-right: 30px;
        display: inline-block;
        text-align: center;
        border-radius: 12px;

        .img {
          display: flex;
          border: 2px solid #fff;
          overflow: hidden;
          margin-bottom: 10px;
          border-radius: 12px;
        }

        img {
          width: 100%;
          transition: all 0.3s ease-in-out;
        }
      }

      .picli:hover {
        color: #D32442;
        cursor: pointer;

        img {
          transform: scale(1.1);
          transition: all 0.3s ease-in-out;
        }
      }

      .picli:last-child {
        margin-right: 0;
      }
    }
  }
}

.logosbar {
  display: flex;
  color: #999;
  font-size: 14px;
  align-items: center;

  .logos {
    width: 18px;
    height: 18px;
    margin-right: 5px;
  }
}

.homeAbout {
  background: #fff;
  padding: 80px 0;

  .container {

    display: flex;
    justify-content: space-around;
  }

  .left {
    width: 32%;

    img {
      width: 220px;
    }
  }

  .mid {
    padding: 60px 0;
    width: 36%;
    font-size: 14px;


  }

  .right {
    width: 32%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;

    img {
      width: 220px;
    }
  }



  h3 {
    font-size: 40px;
    margin: 10px 0 0 0;
    padding: 0;
    color: #000;
  }

  p {
    color: #666;
    margin-bottom: 20px;
    line-height: 2;
  }

}


.homejoin {
  padding-bottom: 80px;

  .logosbar {
    margin-top: 50px;
  }

  img {
    width: 100%;
    border-radius: 12px;
  }
}

// 移动端适配样式
@media (max-width: 768px) {
  .home {
    h2 {
      font-size: 1.5rem !important;
      margin: 1rem 0 !important;
    }

    .sintro {
      font-size: 0.9rem;
      margin-bottom: 1rem;
    }

    .banner {
      height: 25rem !important;
      background-size:auto;

      .banner-text {
        margin-left: 1rem !important;

        h2 {
          font-size: 1.8rem !important;
          line-height: 1.4em !important;
        }

        h5 {
          font-size: 1.1rem !important;
        }
      }

      .toptitle2 {
        margin-top: 0 !important;
        opacity: 1 !important;
        transition: all 500ms ease-in-out !important;
      }
    }

    .midbanner {
      padding: 1.5rem 1rem !important;
      margin: 0 0 2rem 0 !important;

      .piclist {
        width: 100% !important;

        .picli {
          width: 100% !important;
          margin: 0 0 1rem 0 !important;
          padding: 0 !important;

          &:last-child {
            margin-bottom: 0 !important;
          }

          .text {
            font-size: 0.9rem !important;
          }
        }
      }
    }
  }

  .logosbar {
    font-size: 0.8rem !important;
    margin-bottom: 0.5rem !important;

    .logos {
      width: 12px !important;
      height: 12px !important;
      margin-right: 4px !important;
    }
  }

  .homeAbout {
    padding: 2rem 1rem !important;

    .container {
      flex-direction: column !important;
      align-items: center !important;
      text-align: center !important;
    }

    .left,
    .right {
      width: 100% !important;
      margin-bottom: 1rem !important;
      display: flex !important;
      justify-content: center !important;
    }

    .mid {
      width: 100% !important;
      padding: 1rem 0 !important;

      h2 {
        font-size: 1.5rem !important;
      }

      p {
        font-size: 0.9rem !important;
      }
    }
  }

  .homejoin {
    padding: 2rem 1rem !important;

    .el-row {
      flex-direction: column-reverse !important;
      margin:0 !important;
    }

    .el-col {
      &:first-child {
        width: 100% !important;
        margin-bottom: 1rem;
      }

      &:last-child {
        width: 100% !important;
      }
    }

    h2 {
      font-size: 1.3rem !important;
    }

    p {
      font-size: 0.9rem !important;
    }
  }

  .container {
    padding: 0 1rem !important;
  }
}
</style>